export const updateList = new Map([
  [176, [176, 177, 174, 170]],
  [78, [176, 177, 174, 170]],
  [76, [176, 177, 174, 170]],
  [173, [176, 177, 174, 170]],
  [67, [176, 177, 174, 170]],
  [164, [176, 177, 174, 170]],
  [161, [176, 177, 174, 170]],
  [0, [176, 177, 174, 170]],
  [179, [176, 177, 174, 170]],
  [180, [176, 177, 174, 170]]
]);
